import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PropTypes from "prop-types";
import ShareIcon from "@mui/icons-material/Share";

const SVPShareButton = ({
    options,
    isLoading = false,
}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const menuOpen = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return <>
        {!isLoading ?
            <Button
                variant="outlined"
                className="cta-btn float-end mb-3 z-2"
                id="shareBtn"
                aria-controls={menuOpen ? "menu" : undefined}
                aria-haspopup="true"
                aria-expanded={menuOpen ? "true" : undefined}
                onClick={handleClick}
                endIcon={<ShareIcon />}
                disabled={isLoading}
            >
                Share
            </Button> :
            <Button
                variant="outlined"
                className="cta-btn float-end mb-3 z-2"
                id="loadingBtn"
                disabled={true}
            >
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Loading...
            </Button>
        }
        <Menu
            id="menu"
            anchorEl={anchorEl}
            open={menuOpen}
            onClose={handleClose}
            MenuListProps={{
                "aria-labelledby": "exportBtn",
                "style": {textAlign: "center"},
            }}
            slotProps={{
                paper: {
                    sx: {width: 200},
                },
            }}
        >
            {
                options.map((option, index) => {
                    return <MenuItem
                        key={index}
                        onClick={() => {
                            option.onClick();
                            handleClose();
                        }}
                        sx={{justifyContent: "left", textAlign: "center", ml: 2}}
                    >
                        {option.text}
                    </MenuItem>;
                })
            }
        </Menu>
    </>;
};

SVPShareButton.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.object,
            onClick: PropTypes.func,
        }),
    ),
    isLoading: PropTypes.bool,
};

export default SVPShareButton;
